module.exports = __webpack_public_path__ + "static/media/areYouSure.07811516.png";